import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defer, Observable, of } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { GlobalNotification } from '../../home/models/notifications.model';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';

const notificationStorageKey = 'hiddenNotification';
const notificationEndpointBaseUrl = '/api/notifications'

@Injectable({ providedIn: 'root' })
export class ReleaseNotesService {

  /**
   * Single shared stream for the latest release notification. Sidebar and home both
   * subscribe here so the HTTP call runs at most once per session (until cache expires).
   */
  public readonly releaseNotes$: Observable<GlobalNotification> = defer(() => {
    const cache = this.storage.getItem<GlobalNotification>('releaseNotification');
    if (!!cache) {
      return of(cache);
    }

    return this.httpClient.get<GlobalNotification>(`${notificationEndpointBaseUrl}/notifications/release`).pipe(
      tap((data) => {
        this.storage.setItem('releaseNotification', data, 24);
      })
    );
  }).pipe(
    shareReplay({ bufferSize: 1, refCount: false }),
  );

  public constructor(private httpClient: HttpClient,
    private _router: Router,
    private storage: LocalStorageService
  ) { }

  public getLatestReleaseNotification(): Observable<GlobalNotification> {
    return this.releaseNotes$;
  }

  public getHiddenNotifications = (): GlobalNotification[] => {
    const notifications = (JSON.parse(localStorage.getItem(notificationStorageKey)!) || []
    ) as GlobalNotification[];
    return notifications.filter(it => it != null);
  };

  public updateHiddenNotifications = (latestReleaseNote: GlobalNotification) => {
    localStorage.removeItem(notificationStorageKey);

    const releaseNotesStr = JSON.stringify([latestReleaseNote]);
    localStorage.setItem(notificationStorageKey, releaseNotesStr);
  };
}
